import { createFileRoute, useNavigate } from '@tanstack/react-router';
import * as React from 'react';
import BluecoinDetail from '../../components/Bluecoins/Detail';

export const Route = createFileRoute('/_authenticated/bluecoins/detail/$id')({
  beforeLoad: ({ context }) => {
    return {
      ...context,
      documentTitle: {
        main: 'bluecoin.modal.title',
        suffix: 'menu.bluecoins',
      },
    };
  },
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  component: BluecoinDetailRoute,
});

function BluecoinDetailRoute() {
  const { id } = Route.useParams();
  const navigate = useNavigate();

  const handleClose = React.useCallback(() => {
    navigate({ to: '/bluecoins' });
  }, [navigate]);

  return <BluecoinDetail id={id} closeCallback={handleClose} />;
}
